<template>
  <div class="case-detail"
       ref="content">
    <heade-title :title="title"
                 :showClose="showClose"
                 @closePage='closePage'></heade-title>
    <div class="content">
      <div class="content-title">
        <div>
          <div class="case-no"><span>Case ID : </span><span>{{caseInfo.caseNo}}</span></div>
          <div class="case-name">{{caseInfo.issueTitle}}</div>
        </div>
        <el-tooltip class="tooltip"
                    effect="dark"
                    content="The case has already been escalated"
                    placement="top"
                    :disabled="caseInfo.upgrade == 0">
          <div class="sp_escslate">
            <el-button class="escalate-btn"
                       :disabled="caseInfo.status == 0 || caseInfo.upgrade == 1"
                       type="primary"
                       size="medium"
                       @click="handleEscslate">{{caseInfo.upgrade == 0?'Escalate':'Escalated'}}</el-button>
          </div>
        </el-tooltip>
      </div>
      <div class="case-content">
        <div class="case-info">
          <div class="info-content">
            <div class="title-label">Case Infomation</div>
            <div class="info-detail">
              <div class="detail-content flex-box">
                <div class="detail-item item-box">
                  <span class="label">Issue Severity：</span>
                  <span :style="impactLevelDic[caseInfo.impactLevel]?impactLevelDic[caseInfo.impactLevel].color:'color:#2b2b2b;'"
                        class="severity-item">{{impactLevelDic[caseInfo.impactLevel]?impactLevelDic[caseInfo.impactLevel].name:"-"}}</span>
                </div>
                <div class="detail-item item-box">
                  <span class="label">Product：</span>
                  <span class="item">{{prodectDic[caseInfo.product]}}</span>
                </div>
                <div class="detail-item item-box">
                  <span class="label">SN：</span>
                  <span class="item">{{caseInfo.sn?caseInfo.sn:'-'}}</span>
                </div>
              </div>
              <div class="detail-content flex-box">
                <div class="detail-item item-box">
                  <span class="label">Status：</span>
                  <span class="item"
                        :class="{'open':caseInfo.status === 1}">{{caseInfo.status === 0 ? 'Closed' : 'Open'}}</span>
                </div>
                <div class="detail-item item-box">
                  <span class="label">Version :</span>
                  <span class="item">{{versionList[0]?versionList[0].name:'-'}}</span>
                </div>
                <div class="detail-item item-box">
                  <span class="label">Gateway ID：</span>
                  <span class="item">{{caseInfo.gatewayId?caseInfo.gatewayId:'-'}}</span>
                </div>
              </div>
              <div class="label">Issue Descriptions：</div>
              <p class="des-item">{{caseInfo.issueDescriptions}}</p>
              <div class="label">Upload Files：</div>
              <div class="file">
                <div v-for="(item,index) in fileList"
                     :key="index">
                  <span>
                    <svg-icon class="svg-icon"
                              icon-class="fileicon" />
                  </span>
                  <span @click="downloadFile(item)"
                        class="file-name">{{item.name}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="info-table">
            <div class="table-tab">
              <div class="tab"
                   v-for="val in tabsfilter"
                   :key="val.id"
                   @click="handleTabs(val.id)"
                   :class="{is_active:activeIndex == val.id}">{{val.name}}</div>
            </div>
            <div class="tab-line"></div>
            <common-table class="table"
                          v-if="activeIndex == 1"
                          :tableData="emailRecordData"
                          :tableHeadList="emailRecordHead">
              <template v-slot:operation="slot">
                <el-button type="text"
                           size="small"
                           @click="emailRecordDetail(slot.scope.row)">Detail</el-button>
              </template>
            </common-table>
            <common-table class="table"
                          v-if="activeIndex == 2"
                          :tableData="dailySummaryData"
                          :tableHeadList="dailySummaryHead"><template v-slot:dailyOperation="slot">
                <el-button type="text"
                           size="small"
                           @click="dailySummaryDetail(slot.scope.row)">Detail</el-button>
              </template>
            </common-table>
            <div class="service-content"
                 v-if="activeIndex == 3&&caseDetailMsg.row.status==0">
              <div class="service-label">
                <span class="rule">*</span>
                <span class="label">Please rate us</span>
              </div>

              <div class="sp-stepMark-content">
                <div class="slider">
                  <div class="sp_stepMark">
                    <span v-for="val in marks"
                          :key="val"
                          :class="{stpeActive:evaluationForm.rate==val}">{{val}}</span>
                  </div>
                  <el-slider :disabled="caseDetailMsg.row.isRate == 1"
                             @change="handleSlider"
                             :show-tooltip="false"
                             v-model="evaluationForm.rate"
                             :step="1"
                             :max="10"></el-slider>
                  <div class="message-label">
                    <span>Very Disatisfied</span>
                    <span>Very satisfied</span>
                  </div>
                </div>
                <div class="sp_stepPpint">
                  <p><span>{{evaluationForm.rate}}</span>point</p>
                </div>
              </div>
              <!-- <div class="sp_stepPpint">
                <p><span>{{evaluationForm.rate}}</span>point</p>
              </div> -->
              <div class="service-label">
                <span class="rule">*</span>
                <span class="label">it helpful to your future maintenance of the device?</span>
              </div>
              <div class="sp_stpeRadio">
                <div class="stperadio-content"
                     v-for="val in stpeRadio"
                     :key="val.id"
                     :class="{radioActive:evaluationForm.isHelpful==val.id,is_disabled:caseDetailMsg.row.isRate == 1}"
                     @click="handleRateRadio(val.id)">
                  <svg-icon class="stperadio-icon"
                            :icon-class="evaluationForm.isHelpful==val.id?val.activeIcon:val.icon" />{{val.name}}
                </div>
              </div>
              <el-form class="form"
                       :model="evaluationForm"
                       ref="evaluationForm">
                <div v-if="evaluationForm.rate<=6">
                  <div class="top-message">Reasons for low scores :</div>
                  <div class="bottom-message">Up to three options are available</div>
                  <el-form-item class="scores-type"
                                prop="lowScoresType">
                    <el-checkbox-group v-model="evaluationForm.lowScoresType"
                                       :max="3"
                                       @change="lowScoresTypeChange">
                      <el-checkbox :disabled="caseDetailMsg.row.isRate == 1"
                                   v-for="val in reasonsList"
                                   :label="val.value"
                                   :key="val.value"
                                   name="type">{{val.label}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item v-if="evaluationForm.lowScoresType.includes('7')"
                                class="reason"
                                prop="lowScoresReason">
                    <el-input :disabled="caseDetailMsg.row.isRate == 1"
                              type="textarea"
                              ref="input"
                              placeholder="Please enter detail other reasons"
                              v-model="evaluationForm.lowScoresReason"
                              :autosize="{minRows: 6, maxRows: 8}"></el-input>
                  </el-form-item>
                </div>
                <div class="label comments-label">Comments :</div>
                <el-form-item prop="comment">
                  <el-input :disabled="caseDetailMsg.row.isRate == 1"
                            type="textarea"
                            ref="input"
                            placeholder="Please enter comments"
                            v-model="evaluationForm.comment"
                            :autosize="{minRows: 6, maxRows: 8}"></el-input>
                </el-form-item>

              </el-form>
              <div class="form-btn">
                <el-button :disabled="caseDetailMsg.row.isRate == 1"
                           type="primary"
                           size="medium"
                           :loading="rateLoading"
                           @click="submitComment('evaluationForm')">Submit</el-button>
                <el-button plain
                           size="medium"
                           @click="closePage">Cancel</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="dividing-line"></div>
        <div class="contact">
          <div class="contact-content">
            <div class="title-label">Contact Person</div>
            <div class="contact-detail">
              <div class="user-info flex-box">
                <div class="user-item item-box">
                  <span class="label">Contact Person:</span>
                  <span class="item">{{caseInfo.contact}}</span>
                </div>
                <div class="user-item item-box">
                  <span class="label">Telephone :</span>
                  <span class="item">{{caseInfo.telephone && caseInfo.areaCode ? areaCode + ' ' +  caseInfo.telephone:'-'}}</span>
                </div>
              </div>
              <div class="label">Email：</div>
              <div class="item">{{caseInfo.email?caseInfo.email:'-'}}</div>
              <div class="label">CC Email：</div>
              <div v-show="cceMail && cceMail.length && cceMail[0]"
                   class="cc-email-content">
                <div v-for="(item,index) in cceMail"
                     :key="index">{{item}}</div>
              </div>
              <div class="cc-email-content"
                   v-show="!cceMail || (cceMail && !cceMail[0])">-</div>
              <div class="label">Time Zone：</div>
              <div class="item">{{timeZone(caseInfo.timeZone)[0]?timeZone(caseInfo.timeZone)[0].timeZone:'-'}}</div>
              <div class="label">Preferred Date & Time：</div>
              <div class="item">{{caseInfo.timeStamp? moment(parseInt(caseInfo.timeStamp)).format("YYYY-MM-DD HH:mm:ss"): "-"}}</div>
            </div>
            <div class="title-label">Other</div>
            <div class="other-detail">
              <div class="other-info flex-box">
                <div class="other-item item-box">
                  <span class="label">Submit by：</span>
                  <span class="item">{{caseInfo.createdByName}}</span>
                </div>
                <div class="other-item item-box">
                  <span class="label">Updated Date：</span>
                  <span class="item">{{caseInfo.modifiedDate?moment(caseInfo.modifiedDate).format('YYYY-MM-DD HH:mm:ss'):'-'}}</span>
                </div>
              </div>
              <div class="other-info">
                <div class="other-item item-box">
                  <span class="label">Created Time：</span>
                  <span class="item">{{caseInfo.createdDate?moment(caseInfo.createdDate).format('YYYY-MM-DD HH:mm:ss'):'-'}}</span>
                </div>
                <div class="other-item item-box">
                  <span class="label">Escalation Time：</span>
                  <span class="item">{{caseInfo.upgradeTime?moment(caseInfo.upgradeTime).format('YYYY-MM-DD HH:mm:ss'):'-'}}</span>
                </div>
              </div>
              <div class="label">Closed Time：</div>
              <div class="item">{{caseInfo.closeTime?moment(caseInfo.closeTime).format('YYYY-MM-DD HH:mm:ss'):'-'}}</div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 组件区域 -->
    <upgrade-case :escslateMsg="escslateMsg"
                  @escslateChildMsg="escslateChildMsg"
                  v-if="escslateMsg.show"></upgrade-case>
    <email-record :emailRecordMsg="emailRecordMsg"
                  @emailRecordChildMsg="emailRecordChildMsg"
                  v-if="emailRecordMsg.show"></email-record>
    <daily-summary :dailySummaryMsg="dailySummaryMsg"
                   @dailySummaryChildMsg="dailySummaryChildMsg"
                   v-if="dailySummaryMsg.show"></daily-summary>
  </div>
</template>
<script>
import HeadeTitle from '../../components/headeTitle.vue'
import commonTable from './commonTable.vue'
import { getCaseInfoApi, getVersionApi, saveCommentApi, getCommentApi, getEmailApi, getDailyApi, downloadApi } from '@/api/case.js'
import moment from "moment"
import UpgradeCase from './upgradeCase.vue'
import EmailRecord from './emailRecord.vue'
import DailySummary from './dailySummary.vue'
export default {
  name: 'caseDetail2',
  components: { HeadeTitle, commonTable, UpgradeCase, EmailRecord, DailySummary },
  data () {
    var checklowScoresReason = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("Please enter reasons for low scores."));
      }
      setTimeout(() => {
        if (value.length < 1000) {
          callback();
        } else {
          callback(
            new Error("Reasons for low scores cannot exceed 1000 characters.")
          );
        }
      }, 200);
    };
    var checkcomment = (rule, value, callback) => {
      if (!value) {
        return callback();
      }
      setTimeout(() => {
        if (value.length < 1000) {
          callback();
        } else {
          callback(
            new Error("Reasons for low scores cannot exceed 1000 characters.")
          );
        }
      }, 200);
    };
    return {
      title: 'Case Detail',
      showClose: true,
      tabsList: [
        { id: 1, name: "Email Records" },
        { id: 2, name: "Daily Summary" },
        { id: 3, name: "Service Evaluation" },
      ],
      activeIndex: 1,
      emailRecordHead: [
        {
          data: {
            label: '#',
            prop: '',
            width: 44
          }
        },
        {
          data: {
            label: 'From',
            prop: 'email',
            // width: 140
          }
        },
        {
          data: {
            label: 'Email Title',
            prop: 'emailTitle',
            //width: 400
          }
        },
        {
          data: {
            label: 'Date',
            prop: 'createdDate',
            width: 200
          }
        },
        {
          slot: 'operation',
          data: {
            label: 'Operation',
            prop: 'createdByName',
            width: 100
          }
        },
      ],
      dailySummaryHead: [
        {
          data: {
            label: '#',
            prop: '',
            width: 44
          }
        },
        {
          data: {
            label: 'Date',
            prop: 'createdDate',
            width: 200
          }
        },
        {
          data: {
            label: 'Daily Content',
            prop: 'content',
            // width: 639
          }
        },
        {
          data: {
            label: 'Handler',
            prop: 'createdByName',
            width: 200
          }
        },
        {
          slot: 'dailyOperation',
          data: {
            label: 'Operation',
            prop: 'createdByName',
            width: 100
          }
        },
      ],
      emailRecordData: [],
      dailySummaryData: [],
      evaluationForm: {
        rate: 10,
        isHelpful: 1,
        lowScoresType: [],
        lowScoresReason: '',
        comment: '',
      },
      evaluationRules: {
        lowScoresType: [
          { required: "true", message: "Please select reasons for low scores.", trigger: "change", }
        ],
        lowScoresReason: [
          { required: "true", validator: checklowScoresReason, trigger: "blur", }
        ],
        comment: [
          { required: "true", validator: checkcomment, trigger: "blur", }
        ],
      },
      marks: {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        10: 10,
      },
      stpeRadio: [
        { id: 1, name: 'Yes', icon: 'yes', activeIcon: "activeYes" },
        { id: 2, name: 'No', icon: 'no', activeIcon: "activeNo" },
      ],
      caseInfo: {},
      versionList: [],
      reasonsList: [
        { label: "Slow response", value: "1" },
        { label: "Solved inefficiently", value: "2" },
        { label: "Weak technical ability", value: "3" },
        { label: "Bad attitude", value: "4" },
        { label: "Product issue", value: "5" },
        { label: "Issue not solved", value: "6" },
        { label: "Others", value: "7" },
      ],
      impactLevelDic: {
        4: { name: "Low", color: { color: "#2684FF", 'background-color': '#EBF3FF' } },
        3: { name: "Medium", color: { color: "#FF9500", 'background-color': '#FCF0E3' } },
        2: { name: "High", color: { color: "#D94B4B", 'background-color': '#FCE8E8' } },
        1: { name: "Critical", color: { color: "#900E0E", 'background-color': '#F3E6E6' } },
      },
      rateLoading: false,
      timeStampList: [],
      filter: {
        caseNo: "",
        pageSize: 10,
        pageNumber: 1,
      },
      escslateMsg: {
        show: false,
        row: {},
      },
      defaultFilter: {},
      emailRecordMsg: {
        show: false,
        row: {},
      },
      emailRecordLoading: false,
      dailySummaryMsg: {
        show: false,
        row: {},
      },
      dailySummaryloading: false,
      fileList: [],
      productList: [],
    }
  },
  props: {
    caseDetailMsg: {
      typr: Object,
      required: true,
      default: () => { }
    }
  },
  // watch: {
  //   '$store.state.user.loadCasePage': {
  //     handler (val) {
  //       if (val) {
  //         this.$emit('caseDetailChildMsg', { close: false })
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  computed: {
    //获取国家区号
    areaCode () {
      const areaCodeList = this.$ls.get('AreaCode')
      const currentAreaCode = areaCodeList.find(item => {
        return item.id === Number(this.caseInfo.areaCode)
      })
      return currentAreaCode.areaCode
    },

    prodectDic () {
      let dicObj = {};
      for (var i in this.productList) {
        let key = Object.values(this.productList[i])[0]
        dicObj[key] = Object.values(this.productList[i])[2]
      }
      return dicObj
    },

    moment () {
      return moment
    },

    timeZone () {
      return function (data) {
        let timeZoneArr = this.timeStampList.filter(val => {
          if (val.id == data) {
            return true;
          }
        })
        return timeZoneArr
      }
    },
    tabsfilter () {
      let [...tabsArr] = this.tabsList
      if (this.caseDetailMsg.row.status == 1) {
        tabsArr.splice(2, 1)
      } else {
        tabsArr = this.tabsList
      }
      return tabsArr
    },
    cceMail () {
      return JSON.parse(this.caseDetailMsg.row.ccEmail)
    }
  },
  created () {
    this.activeIndex = this.caseDetailMsg.isRate ? 3 : 1;
    this.defaultFilter = JSON.parse(JSON.stringify(this.filter))
    this.getCaseInfo()
    this.handleSearch()
    this.productList = this.$ls.get('product');
    this.timeStampList = this.$ls.get('timeZone');
    if (this.caseDetailMsg.row.isRate == 1) {
      this.getComment()
    }
  },
  mounted () {
    if (this.caseDetailMsg.type === 'rate') {
      setTimeout(() => {
        const scrollHeight = this.$refs.content.scrollHeight
        this.$refs.content.scrollTop = scrollHeight
      }, 200);
    }
  },
  methods: {
    closePage () {
      this.$emit('caseDetailChildMsg', { isSave: false, close: false })
    },
    //是否有帮助
    handleRateRadio (data) {
      if (this.caseDetailMsg.row.isRate == 1) return
      this.evaluationForm.isHelpful = data
    },
    //选择分数
    handleSlider (val) {
      if (val > 6) {
        this.evaluationForm.lowScoresType = [];
        this.evaluationForm.lowScoresReason = '';
      }
    },

    //切换标签页
    handleTabs (data) {
      this.activeIndex = data;
      this.filter = JSON.parse(JSON.stringify(this.defaultFilter))
      this.total = 0;
      this.handleSearch()
    },

    //获取工单详情
    getCaseInfo () {
      let params = {
        caseId: this.caseDetailMsg.row.caseId
      }
      getCaseInfoApi(params).then(res => {
        this.caseInfo = res.rows;
        this.fileList = JSON.parse(res.rows.enclosure)
        this.getVersion(this.caseInfo.product)
      }).catch(() => {
        this.caseInfo = JSON.parse(JSON.stringify(this.caseDetailMsg.row));
        this.fileList = JSON.parse(this.caseInfo.enclosure)
        this.getVersion(this.caseInfo.product)
      })

    },
    //打开邮件详情
    emailRecordDetail (row) {
      this.emailRecordMsg.show = true;
      this.emailRecordMsg.row = row;
    },

    //关闭邮件详情
    emailRecordChildMsg (data) {
      this.emailRecordMsg.show = data.close
    },

    //获取表格详情
    handleSearch () {
      if (this.activeIndex == 1) {
        this.emailRecordLoading = true;
        let params = JSON.parse(JSON.stringify(this.filter))
        params.caseNo = this.caseDetailMsg.row.caseNo
        getEmailApi(params).then(res => {
          this.emailRecordData = res.rows.rows;
          this.total = res.rows.total;
          this.emailRecordLoading = false;
        }).catch(() => {
          this.emailRecordLoading = false;
          this.emailRecordData = [];
          this.total = 0;
        })
      } else {
        this.dailySummaryloading = true;
        let params = JSON.parse(JSON.stringify(this.filter))
        params.caseNo = this.caseDetailMsg.row.caseNo
        getDailyApi(params).then(res => {
          console.log(res);
          this.dailySummaryData = res.rows.rows;
          this.dailySummaryData.forEach((val, index) => {
            val.dailyContent = val.dailyContent.replace(/<img src="(.*?)" style="(.*?)">/g, '<a href="$1" target="_blank" style="color:#0c60e1;">$1</a>')
          })
          this.total = res.rows.total;
          this.dailySummaryloading = false;
        }).catch(() => {
          this.dailySummaryData = [];
          this.total = 0;
          this.dailySummaryloading = false;
        })
      }
    },

    //打开日报详情
    dailySummaryDetail (row) {
      this.dailySummaryMsg.show = true;
      this.dailySummaryMsg.row = row;
    },

    //关闭日报详情
    dailySummaryChildMsg (data) {
      this.dailySummaryMsg.show = data.close;
    },

    //获取版本号
    getVersion (data) {
      let params = {
        id: data + ''
      }
      getVersionApi(params).then(res => {
        this.versionList = res.rows.filter(val => {
          if (val.id == this.caseInfo.version) {
            return true;
          }
        })
      })
    },

    //自动聚焦
    lowScoresTypeChange (val) {
      if (val.includes("7")) {
        this.$nextTick(() => {
          this.$refs.input.focus();
        });
      }
    },

    //打开升级工单页面
    handleEscslate () {
      this.escslateMsg.row = this.caseDetailMsg.row;
      this.escslateMsg.show = true;
    },

    //关闭升级工单页面
    escslateChildMsg (data) {
      if (data.isSave) {
        this.getCaseInfo()
      }
      this.escslateMsg.show = data.close;
    },

    //评价
    submitComment (evaluationForm) {
      this.$refs[evaluationForm].validate(valid => {
        if (valid) {
          this.rateLoading = true;
          let params = JSON.parse(JSON.stringify(this.evaluationForm))
          params.caseNo = this.caseDetailMsg.row.caseNo
          params.lowScoresType = params.lowScoresType.join(',')
          saveCommentApi(params).then(res => {
            this.rateLoading = false
            this.$message.success('Submit sucessfully!')
            setTimeout(() => {
              this.$emit("caseDetailStatus", { close: false, isSave: true });
            }, 500);
          }).catch(() => {
            this.rateLoading = false
          })
        }
      })
    },

    //获取评价内容
    getComment () {
      let params = {
        caseNo: this.caseInfo.caseNo ? this.caseInfo.caseNo : this.caseDetailMsg.row.caseNo
      }
      getCommentApi(params).then(res => {
        console.log(res);
        let caseCommentData = res.rows[0]
        this.evaluationForm.rate = Number(caseCommentData.rate)
        this.evaluationForm.isHelpful = caseCommentData.isHelpful
        this.evaluationForm.lowScoresType = caseCommentData.lowScoresType.split(',')
        this.evaluationForm.lowScoresReason = caseCommentData.lowScoresReason
        this.evaluationForm.comment = caseCommentData.comment
      })
    },

    //下载文件
    downloadFile (data) {
      downloadApi({ groupUrl: data.groupUrl }).then(res => {
        const a = document.createElement('a')
        const blob = new Blob([res])
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', data.name)
        a.click()
        URL.revokeObjectURL(objectUrl)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.case-detail {
  width: 100%;
  height: 100%;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-y: auto;
  .content {
    background-color: #ffffff;
    height: calc(100% - 40px);
    width: 100%;
    min-width: 1094px;
    .content-title {
      padding: 12px 36px;
      display: flex;
      justify-content: space-between;
      background-color: #fafbfc;
      border-bottom: 1px solid #e9edf2;
      .case-no {
        height: 20px;
        font-size: 14px;
        margin-bottom: 4px;
        color: #333940;
      }
      .case-name {
        min-height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #13161a;
        font-weight: 500px;
        word-break: break-all;
        margin-right: 32px;
      }
      .tooltip {
        display: flex;
        align-items: center;
        .escalate-btn {
          width: 96px;
          height: 35px;
        }
      }
    }
    .case-content {
      display: flex;
      justify-content: space-between;
      position: relative;
      height: calc(100% - 73px);
      .case-info {
        width: calc(100% - 412px);
        min-width: 665px;
        margin: 0 16px;
        padding: 16px 20px;
        .info-content {
          margin-bottom: 12px;
          .info-detail {
            font-size: 14px;
            margin-bottom: 24px;
            .detail-content {
              .detail-item:nth-child(3) {
                width: 265px;
              }
              .severity-item {
                display: inline-block;
                height: 22px;
                line-height: 22px;
                padding: 0 8px;
                width: auto;
              }
            }
            .des-item {
              color: #333940;
              line-height: 20px;
              white-space: pre-wrap;
              margin-bottom: 12px;
              word-wrap: break-word;
            }
            .file {
              font-size: 14px;
              line-height: 20px;
              margin-bottom: 4px;
              .svg-icon {
                margin-right: 4px;
              }
              .file-name {
                color: #006bf5;
                cursor: pointer;
              }
            }
          }
        }
        .info-table {
          overflow: auto;
          .table-tab {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            width: 100%;
            .tab {
              margin-right: 16px;
              height: 44px;
              display: flex;
              align-items: center;
              padding: 11px 8px;
            }
            .is_active {
              border-bottom: 2px solid #2684ff;
            }
          }
          .tab-line {
            margin-top: 1px;
            border-top: 1px solid #f0f3f7;
          }
          .table {
            width: 100%;
          }
          .service-content {
            padding: 16px 20px;
            max-width: 960px;
            min-width: 625px;
            .service-label {
              position: relative;
              height: 20px;
              margin-bottom: 4px;
              .rule {
                position: absolute;
                left: -8px;
                width: 8px;
                color: #e65050;
              }
              .label {
                color: #545c66;
              }
            }
            .sp_stpeRadio {
              height: 36px;
              margin-bottom: 12px;
              display: flex;
              align-items: center;
              .stperadio-content {
                display: flex;
                align-items: center;
                height: 36px;
                padding: 8px 16px;
                background: #ffffff;
                border: 1px solid #d3d9e0;
                border-radius: 2px;
                margin-right: 16px;
                .stperadio-icon {
                  height: 20px;
                  width: 20px;
                  margin-right: 8px;
                }
              }
              .radioActive {
                color: #007aff;
                border-color: #007aff;
              }
              .is_disabled {
                border-color: #c0c4cc;
                cursor: no-drop;
                // color: #C0C4CC;
                background-color: #f5f7fa;
              }
            }
            .sp-stepMark-content {
              width: 100%;
              display: flex;
              align-items: center;
              margin-bottom: 12px;
              .slider {
                width: calc(100% - 100px);
                margin-right: 20px;
                .sp_stepMark {
                  margin-left: -10px;
                  margin-right: -9px;
                  display: flex;
                  justify-content: space-between;
                  span {
                    width: 20px;
                    text-align: center;
                  }
                }
                .message-label {
                  display: flex;
                  justify-content: space-between;

                  font-size: 14px;
                  color: #a1a8b3;
                }
              }
              .sp_stepPpint {
                color: #2684ff;
                p {
                  font-size: 14px;
                  color: #2684ff;
                  display: flex;
                  align-items: center;
                  span {
                    font-size: 24px;
                    margin-left: 4px;
                    color: #2684ff;
                  }
                }
              }
            }

            /deep/.el-slider__runway {
              margin: 9px 0 4px;
            }

            .form {
              font-size: 14px;
              .top-message {
                height: 20px;
                line-height: 20px;
                color: #545c66;
              }
              .bottom-message {
                height: 20px;
                line-height: 20px;
                color: #a1a8b3;
              }
              .scores-type {
                margin-bottom: 0px;
              }
              .reason {
                margin-bottom: 12px;
              }
            }
            .form-btn {
              margin-left: -12px;
            }
          }
        }
      }
      .dividing-line {
        height: calc(100% - 32px);
        margin-top: 16px;
        border-right: 1px solid #e9edf2;
      }
      .contact {
        width: 412px;
        .contact-content {
          margin: 16px 0;
          padding: 0 16px 0 36px;
        }
        .contact-detail {
          margin-bottom: 24px;
          .cc-email-content {
            font-size: 14px;
            color: #333940;
            line-height: 20px;
            min-height: 20px;
            margin-bottom: 12px;
          }
          .label {
            height: 20px;
            line-height: 20px;
            margin-bottom: 4px;
            color: #a1a8b3;
          }
          .item {
            display: block;
            height: 20px;
            line-height: 20px;
            color: #333940;
            margin-bottom: 12px;
          }
        }
      }
    }
  }
}
.title-label {
  height: 22px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #13161a;
  margin-bottom: 12px;
}
.flex-box {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.item-box {
  min-width: 160px;
  margin-right: 20px;
}
.label {
  display: block;
  height: 20px;
  line-height: 20px;
  margin-bottom: 4px;
  font-size: 14px;
  color: #a1a8b3;
}
.comments-label {
  font-size: 14px;
  font-weight: 400;
  color: #545c66;
}
.item {
  display: block;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #333940;
  margin-bottom: 12px;
}
.closed {
  color: #79828c;
}
.open {
  color: #30c090;
}
@media screen and (max-width: 1366px) {
  // .content {
  //   overflow-x: auto;
  // }
}
</style>